import React from 'react';

function SuggestedColors({ data }) {
    // if (!data || !data[0] || !data[0].suggested_color_1) return null;

    const suggestedColors = data;

    return (
        <div className="my-8">
            <h2 className='text-center font-inter text-2xl font-bold text-slate-800 mt-6'>Explore More Background Variations</h2>
            <h3 className="text-lg text-center text-gray-600 mb-4">Do you need any other color? We've got you covered!</h3>
            <div className="flex justify-center text-center space-x-4">
                {suggestedColors.map((colorObj, index) => (
                    <a
                        key={index}
                        href={colorObj.link}
                        className="flex justify-center items-center w-32 h-12 rounded-full bg-white border hover:bg-crayola-800 hover:text-white border-crayola-500 text-gray-900 font-inter text-lg"

                    >
                        <span>{colorObj.color}</span>
                    </a>
                ))}
            </div>
        </div>
    );
}

export default SuggestedColors;
